import React from "react";
import axios from "axios";
import { notifications } from '@mantine/notifications';
import { Group, Text, Box } from '@mantine/core';
import { Carousel } from '@mantine/carousel';
import { IconTrash } from '@tabler/icons-react';

import { useLoginContext } from "../../context/loginContext";
import { BE_API_THREE, utils, ROOT_BASE_URL } from "../../utils/globalVariables";

import ModalResponse from "../../components/general/ModalResponse";
import ModalTakeAction from "../../components/general/ModalTakeAction";
import InputWrapperCustom from "../../components/general/InputWrapperCustom";

import SedangJemputFotoDropper from "./SedangJemputFotoDropper";

const SedangJemputFoto = ({ dataDataKey, stateData, fnOnChange, fnClickPhoto }) => {

    const mountedRef = React.useRef(true);
    const { loginContext, handleSetLoginContext } = useLoginContext();

    const heightImage = 150;

    const notificationId = React.useRef({
        errorDeleteData: 'sedangJemputFoto-1',
    })

    const canEditBarangActual = React.useRef([
        utils.penjemputanSteps.nota.value,
        utils.penjemputanSteps.segera_menjemput.value,
        utils.penjemputanSteps.sedang_menjemput.value,
    ])

    const [data, setData] = React.useState({
        deleteModal: false,
        deleteId: '',
        deleteName: '',
        deleteLoading: false,

        modalResponse: {
            show: false,
            type: utils.modalResponse.warning,
            hideOnClickOutSide: false,
            content: ''
        }
    });

    React.useEffect(() => {
        return () => {
            mountedRef.current = false;
        }
    }, [])

    const deleteData = () => {
        setData(d => ({ ...d, deleteLoading: true }));

        const formDT = new FormData();
        const formDTHeader = { 'Content-Type': 'application/json' }

        formDT.append('json_token', loginContext.syswebapp);
        formDT.append('trx_id', stateData.trxId);
        // formDT.append('primary_key_id', stateData.primaryKeyId);
        formDT.append('current_step', stateData.currentStep);
        formDT.append('is_cancel', stateData.isCancel);
        formDT.append('foto_id', data.deleteId);
        formDT.append('foto_name', data.deleteName);

        axios({
            method: 'post',
            url: BE_API_THREE + '/delete_delivery_jemput_foto',
            data: formDT,
            headers: formDTHeader,
        }).then((response) => {
            if (!mountedRef.current) return null;

            setData(d => ({ ...d, deleteLoading: false, deleteModal: false }));

            if (response.data.flag_status === 'isset') {
                fnOnChange(response.data.data);
            }

            if (response.data.flag_status === 'error') {
                notifications.show({
                    id: notificationId.current.errorDeleteData,
                    title: utils.notification.warning.caption,
                    message: response.data.pesan,
                    color: utils.notification.warning.color,
                    icon: utils.notification.warning.icon,
                    withBorder: true,
                    autoClose: true,
                })
            }

            if (response.data.flag_status === 'no-data') {
                setData(d => ({
                    ...d,
                    modalResponse: {
                        ...d.modalResponse,
                        type: utils.modalResponse.warning,
                        hideOnClickOutSide: true,
                        content: 'Data tidak ditemukan.',
                        show: true
                    }
                }))
            }

            if (response.data.flag_status === 'invalid-json-token') {
                handleSetLoginContext(null);
            }

            if (response.data.flag_status === 'user-inactive') {
                handleSetLoginContext(null);
            }
        }).catch(error => {
            if (!mountedRef.current) return null;

            setData(d => ({
                ...d,
                deleteLoading: false,
                deleteModal: false
            }))

            notifications.show({
                id: notificationId.current.errorDeleteData,
                title: utils.notification.warning.caption,
                message: error.message,
                color: utils.notification.warning.color,
                icon: utils.notification.warning.icon,
                withBorder: true,
                autoClose: true,
            })
        })
    }

    return (
        <React.Fragment>
            <InputWrapperCustom
                stateLabel={
                    <Group spacing={6}>
                        <Text fw='normal'>Foto Barang</Text>
                        <Text fw='normal'>({Array.isArray(dataDataKey) ? dataDataKey.length : 0})</Text>
                    </Group>
                }
                stateWithAsterisk={false}
                stateError=''
                stateDescription=''
            >
                {Array.isArray(dataDataKey) && dataDataKey.length > 0 &&
                    <Carousel
                        withIndicators={false}
                        withControls={Array.isArray(dataDataKey) && (dataDataKey.length > 1)}
                        height={heightImage}
                        slideSize="33.333333%"
                        slideGap="xs"
                        loop
                        align="start"
                        mt='md'
                    >
                        {Array.isArray(dataDataKey) && Object.keys(dataDataKey).map((keyFB, index) => {
                            return (
                                <Carousel.Slide
                                    key={keyFB}
                                >
                                    <Box
                                        sx={{
                                            position: 'relative',
                                            height: heightImage + 'px'
                                        }}
                                    >
                                        <img
                                            alt={`foto-barang-${index}`}
                                            src={`${ROOT_BASE_URL}${dataDataKey[keyFB].delivery_jemput_barang_foto_actual_nama}`}
                                            style={{
                                                width: '100%',
                                                height: '100%',
                                                objectFit: 'cover'
                                            }}

                                            onClick={() => fnClickPhoto({
                                                images: dataDataKey,
                                                title: 'Foto Barang',
                                                index: keyFB,
                                                fieldName: 'delivery_jemput_barang_foto_actual_nama',
                                            })}
                                        />

                                        {canEditBarangActual.current.includes(stateData.currentStep) ?
                                            <Box
                                                px='.5rem'
                                                sx={(tema) => ({
                                                    height: '30px',
                                                    backgroundColor: tema.fn.rgba('#404040', 0.75),
                                                    position: 'absolute',
                                                    bottom: 0,
                                                    left: 0,
                                                    right: 0,
                                                    display: 'flex',
                                                    justifyContent: 'space-between',
                                                    alignItems: 'center',
                                                    cursor: 'pointer'
                                                })}

                                                onClick={() => setData(d => ({
                                                    ...d,
                                                    deleteId: dataDataKey[keyFB].delivery_jemput_barang_foto_actual_id,
                                                    deleteName: dataDataKey[keyFB].delivery_jemput_barang_foto_actual_nama,
                                                    deleteModal: true
                                                }))}
                                            >
                                                <Text color="#fff">
                                                    {String(Number(keyFB) + 1)}
                                                </Text>

                                                <IconTrash
                                                    size={18}
                                                    color='#fff'
                                                />
                                            </Box>
                                            :
                                            <Box
                                                px='.5rem'
                                                sx={(tema) => ({
                                                    height: '30px',
                                                    backgroundColor: tema.fn.rgba('#404040', 0.75),
                                                    position: 'absolute',
                                                    bottom: 0,
                                                    left: 0,
                                                    right: 0,
                                                    display: 'flex',
                                                    justifyContent: 'center',
                                                    alignItems: 'center',
                                                })}
                                            >
                                                <Text color="#fff">
                                                    {String(Number(keyFB) + 1)}
                                                </Text>
                                            </Box>
                                        }
                                    </Box>
                                </Carousel.Slide>
                            )
                        })}
                    </Carousel>
                }

                {canEditBarangActual.current.includes(stateData.currentStep) &&
                    <SedangJemputFotoDropper
                        stateData={{
                            trxId: stateData.trxId,
                            primaryKeyId: stateData.primaryKeyId,
                            currentStep: stateData.currentStep,
                            isCancel: stateData.isCancel,
                            // userAccess: stateData.userAccess,
                        }}

                        fnOnAdded={(dataArray) => {
                            fnOnChange(dataArray);
                        }}
                    />
                }
            </InputWrapperCustom>

            <ModalResponse
                stateShow={data.modalResponse.show}
                fnHide={() => setData(d => ({
                    ...d,
                    modalResponse: {
                        ...d.modalResponse,
                        show: false
                    }
                }))}

                stateHideOnClickOutSide={data.modalResponse.hideOnClickOutSide}
                stateType={data.modalResponse.type}
                stateContent={data.modalResponse.content}
            />

            <ModalTakeAction
                stateShow={data.deleteModal}
                fnHide={() => setData(d => ({ ...d, deleteModal: false }))}

                stateHideOnClickOutSide={true}
                stateTitle={String('Confirmation').toUpperCase()}
                stateOverlayZIndex={201}

                stateButtonClosePx='md'

                stateButtonActionCaption='Hapus'
                stateButtonActionPx='xs'
                stateButtonActionColor="red"
                stateButtonActionLoading={data.deleteLoading}
                fnButtonAction={deleteData}
            >
                <Text size='sm'>
                    Hapus foto ini ?
                </Text>
            </ModalTakeAction>
        </React.Fragment>
    )
}

export default SedangJemputFoto;